const initialized = new Set();

function initAuthorBio() {
	const toggles = document.querySelectorAll('.toggle-author-bio');

	toggles.forEach((toggle) => {
		if (!initialized.has(toggle)) {
			const authorBio = toggle.parentElement.querySelector('.author-bio');
			const close = authorBio.querySelector('.close-author-bio');

			toggle.addEventListener('click', () => toggleBio(authorBio));
			close.addEventListener('click', () => closeBio(authorBio));
			initialized.add(toggle);
		}
	});
}

function toggleBio(authorBio) {
	if (authorBio instanceof HTMLDivElement) {
		authorBio.classList.toggle('author-bio-open');
		document.addEventListener('click', outsideCloseBio);
	}

	function outsideCloseBio(event) {
		if (authorBio instanceof HTMLDivElement) {
			const toggle = event.target.closest('.toggle-author-bio');
			if (!(authorBio.contains(event.target)) && toggle === null) {
				closeBio(authorBio);
				document.removeEventListener('click', outsideCloseBio);
			}
		}
	}
}

function closeBio(authorBio) {
	authorBio.classList.remove('author-bio-open');
}

document.addEventListener('DOMContentLoaded', initAuthorBio);
document.addEventListener('content-added', initAuthorBio);